import { Text } from "@chakra-ui/react";
import React from "react";

export default function PageTitle({ children, ...props }: any) {
  return (
    <Text fontWeight="500" fontSize="4xl" color="black.500" as="h1" {...props}>
      {children}
    </Text>
  );
}
